<template>
  <div class="page1 f1">
    People
  </div>
</template>

<script>
export default {
  // import Login from '../components/Login'

  name: 'DashboardPeople',
  data () {
    return {
      // mode: 'login' // login/register
    }
  },
  props: [],
  components: {

  },
  methods: {

  },
  computed: {

  },
  created () {
    // console.log('** Login Component Loaded')
  }
}
</script>

<style scoped lang="scss">
</style>
